/* eslint-disable no-restricted-syntax */
import store from '../index';
import api from '../../backend/api';

const gridAreas = {
  state: {
    initialEventsGotten: false,
    changeInterval: null,
    showIndex: 0,
    shownArea: 'A176798615',
    mapCenter: [9.663738, 54.236640],
    areas: [],
    disorderAreaId: null,
    disorderNodeId: null,
    disorderNodeMSLink: null,
    disorderShowMap: null,
    disorderAreaNodes: null,
    disorderMsg: '',
    endpointDetail: null,
    endpointTypeCount: [],
    allEvents: [],
    stats: {
      numberOfEvents: 0,
      numberOfResolvedEvents: 0,
      numberOfUnresolvedEvents: 0,
    },
  },
  mutations: {
    SET_MAP_CENTER(state, { center, areaId }) {
      state.shownArea = areaId;
      state.mapCenter = center;
    },
    SET_SHOWN_AREA(state, id) {
      state.areas.map((area, index) => {
        if (area.id === id) {
          state.showIndex = index;
          state.shownArea = state.areas[state.showIndex].id;
          state.mapCenter = state.areas[state.showIndex].center;
        }
      });
    },
  },
  actions: {
    SET_EVENT_WEBSOCKET_CONNECTION({ dispatch }) {
      api.eventWebsocketConnection().on('new_event', (msg) => {
        dispatch('SET_DISORDER', msg);
      });
    },
    SET_DISORDER({ state, commit }, payload) {
      state.areas.map((area, index) => {
        if (area.id === payload.grid_area_id) {
          let areaObj;
          // let errorShapeStartPosition = null;
          // const errorShapeCoords = [];
          state.disorderNodeId = payload.endpoint_id;
          state.disorderMsg = payload.message;
          state.disorderShowMap = false;

          let errorType;
          if (payload.severity === 'critical') {
            errorType = 'error';
          } else if (payload.severity === 'warning') {
            errorType = 'warning';
          } else {
            errorType = 'ok';
          }

          const setDisorderToChildNodes = (allEndpoints) => {
            const subNodeIds = [];
            allEndpoints.map((endpoint, index) => {
              subNodeIds.push(endpoint.id);
              areaObj.endpoints.map((node) => {
                if (
                  node.ms_link_number === endpoint.ms_link_number
                  && node.ms_link_number !== state.disorderNodeMSLink
                ) {
                  node.error = errorType;
                }
              });
              if (index === allEndpoints.length - 1 && errorType === 'error') {
                state.disorderShowMap = true;
                state.disorderAreaNodes = areaObj.endpoints;
                state.disorderAreaId = area.id;
              } else if (index === allEndpoints.length - 1 && errorType !== 'error') {
                state.disorderAreaId = -2;
              }
            });
          };

          areaObj = area;
          if (errorType === 'error') {
            state.showIndex = index;
            commit('SET_MAP_CENTER', {
              center: area.position.coordinates,
              areaId: area.id,
            });
          }
          area.error = errorType;
          area.endpoints.map((node) => {
            if (node.id === payload.endpoint_id) {
              state.disorderNodeMSLink = node.ms_link_number;
              node.error = errorType;
              node.isParentError = true;
              node.errorMsg = payload.message;
              setDisorderToChildNodes(payload.endpoints);
              if (errorType !== 'ok') {
                store.dispatch('NEW_NOTIFICATION', {
                  msg: `Störung ${node.ms_link_number} (${node.label_ons}): ${payload.message}`,
                  showNotification: true,
                  color: errorType,
                  hasCloseButton: true,
                  areaId: area.id,
                  autoClose: 66000,
                  endpointId: payload.endpoint_id,
                  originMsg: payload.message,
                });
              } else {
                store.state.notification.notifications.map((notification) => {
                  if (notification.endpointId === node.id) {
                    notification.open = false;
                  }
                });
              }
            }
          });
        }
      });
    },
    GET_ALL_GRID_AREAS({ state, dispatch }, callbackForAllEndpoints) {
      return new Promise((res) => {
        api.getAllGridAreas()
          .then((resp) => {
            state.areas = resp.data.data;
            resp.data.data.map((area) => {
              dispatch('GET_ENDPOINTS_OF_GRID_AREA', area.id)
                .then(() => {
                  // dispatch('GET_ALL_EVENTS', true);
                  if (callbackForAllEndpoints) {
                    state.disorderAreaId = -1;
                    res(resp);
                  }
                });
            });
            if (!callbackForAllEndpoints) {
              res(resp);
            }
          });
      });
    },
    GET_ENDPOINTS_OF_GRID_AREA({ state, dispatch }, gridAreaId) {
      return new Promise((res) => {
        api.getEndpointsByGridAreaId(gridAreaId)
          .then((resp) => {
            state.areas.map((area) => {
              if (area.id === gridAreaId) {
                area.endpoints = resp.data.data;
                area.numberOfEndpoints = area.endpoints.length;
                dispatch('SET_POSITIONS_OF_PARENTS_IN_CHILD');
                res(resp);
              }
            });
            dispatch('GET_ALL_DEVICES');
          });
      });
    },
    SET_POSITIONS_OF_PARENTS_IN_CHILD({ state }) {
      for (const area of state.areas) {
        if (area.endpoints) {
          for (const node of area.endpoints) {
            if (node.endpoint_id) {
              for (const node1 of area.endpoints) {
                if (node1.id === node.endpoint_id) {
                  node.parentPosition = node1.position.coordinates;
                }
              }
            }
          }
        }
      }
    },
    GET_ENDPOINT_DETAILS_BY_ID({ state }, endpoint) {
      state.endpointDetail = endpoint;
      api.getEndpointDetails(endpoint.id)
        .then((resp) => {
          state.endpointDetail = resp.data.data;
        }).catch((error) => {
          console.log(error);
          state.endpointDetail = null;
        });
    },
    GET_ENDPOINT_COUNT_TYPES_BY_ID({ state }, endpoint) {
      return api.getEndpointTypeCount(endpoint.id)
        .then((resp) => {
          state.endpointTypeCount[endpoint.id] = resp.data;
          return resp.data;
        }).catch((error) => {
          console.log(error);
          state.endpointTypeCount = null;
        });
    },
    GET_ALL_EVENTS({ state, dispatch }, setDisorderBool) {
      const unresolvedEvents = [];

      const handleEvent = () => {
        const unresolvedCriticalEventIds = [];
        state.areas.map((area) => {
          unresolvedEvents.slice(0).reverse().map((event, index) => {
            if (area.id === event.grid_area_id) {
              event.endpoints = [];
              api.getAffectedEndpointsByEndpointId(event.endpoint_id)
                .then((resp) => {
                  event.endpoints = resp.data.data;
                  if (
                    event.severity === 'critical'
                    && unresolvedCriticalEventIds.indexOf(event.endpoint_id) === -1
                    && setDisorderBool !== false
                  ) {
                    unresolvedCriticalEventIds.push(event.endpoint_id);
                    dispatch('SET_DISORDER', event);
                  }
                  if (index === unresolvedEvents.length - 1 && setDisorderBool !== false) {
                    dispatch('SET_DISORDER', event);
                  }
                });
            }
          });
        });
      };

      api.getAllEvents()
        .then((resp) => {
          if (state.areas.length > 0) {
            state.areas.map((area) => {
              resp.data.data.map((event, index) => {
                if (area.id === event.grid_area_id) {
                  event.area = area;
                }
                if (index === resp.data.data.length - 1) {
                  state.allEvents = resp.data.data;
                }
                if (event.resolved === false && unresolvedEvents.indexOf(event) === -1) {
                  unresolvedEvents.push(event);
                }
                if (index === resp.data.data.length - 1) {
                  handleEvent();
                }
              });
            });
          } else {
            dispatch('GET_ALL_GRID_AREAS')
              .then(() => {
                state.areas.map((area) => {
                  resp.data.data.map((event, index) => {
                    if (area.id === event.grid_area_id) {
                      event.area = area;
                    }
                    if (index === resp.data.data.length - 1) {
                      state.allEvents = resp.data.data;
                    }
                    if (event.resolved === false && unresolvedEvents.indexOf(event) === -1) {
                      unresolvedEvents.push(event);
                    }
                    if (index === resp.data.data.length - 1) {
                      handleEvent();
                    }
                  });
                });
              });
          }
        });
    },
    GET_INITIAL_EVENTS({ state, dispatch }) {
      if (state.initialEventsGotten === false) {
        dispatch('GET_ALL_GRID_AREAS')
          .then(() => {
            api.getUnresolvedEvents()
              .then((resp) => {
                state.areas.map((area) => {
                  let areaEventCount = 0;
                  resp.data.data.map((event, index) => {
                    if (event.grid_area_id === area.id) {
                      areaEventCount += 1;

                      if (event.severity === 'critical') {
                        area.error = 'error';
                      } else if (event.severity === 'warning' && area.error !== 'error') {
                        area.error = 'warning';
                      }
                    }
                    if (index === resp.data.data.length - 1) {
                      area.eventCount = areaEventCount;
                      if (areaEventCount > 0) {
                        store.dispatch('NEW_NOTIFICATION', {
                          msg: `${area.eventCount} ungelöste Störungen in ${area.label}!`,
                          showNotification: true,
                          color: 'error',
                          hasCloseButton: true,
                          areaId: area.id,
                          autoClose: 20000,
                          originMsg: `${area.eventCount} Störungen in ${area.label}`,
                        });
                      }
                    }
                  });
                });
                state.initialEventsGotten = true;
              });
          });
      }
    },
    RESOLVE_EVENT_BY_ID({ state, dispatch }, event) {
      return new Promise((res) => {
        api.resolveEventByEventId(event.id)
          .then((resp) => {
            res(resp);
            state.areas.map((area) => {
              area.endpoints.map((endpoint) => {
                endpoint.error = null;
                state.disorderAreaId = -1;
              });
              dispatch('GET_ALL_GRID_AREAS')
                .then(() => {
                  dispatch('GET_ALL_EVENTS');
                });
            });
            store.state.notification.notifications.map((notify) => {
              if (notify.originMsg === event.message) {
                notify.open = false;
              }
            });
          });
      });
    },
    RESOLVE_ALL_EVENTS_BY_ENDPOINT({ state, dispatch }, endpointId) {
      return new Promise((res) => {
        api.resolveAllEventsByEndpointId(endpointId)
          .then((resp) => {
            res(resp);
            state.areas.map((area) => {
              area.endpoints.map((endpoint) => {
                endpoint.error = null;
                state.disorderAreaId = -1;
              });
              dispatch('GET_ALL_EVENTS');
            });
            store.state.notification.notifications = [];
          });
      });
    },
    RESOLVE_ALL_EVENTS({ dispatch }) {
      return new Promise((res) => {
        api.resolveAllEvents()
          .then((resp) => {
            res(resp);
            dispatch('GET_ALL_EVENTS');
            store.state.notification.notifications = [];
          });
      });
    },
    GET_STATS({ state }) {
      api.getNumberOfEvents()
        .then((resp) => {
          state.stats.numberOfEvents = resp.data.count;
        });
      api.getNumberOfUnresolvedEvents()
        .then((resp) => {
          state.stats.numberOfUnresolvedEvents = resp.data.count;
        });
      api.getNumberOfResolvedEvents()
        .then((resp) => {
          state.stats.numberOfResolvedEvents = resp.data.count;
        });
    },
    GET_ALL_DEVICES({ state }, noReload) {
      api.getAllDevices()
        .then((resp) => {
          resp.data.data.map((device, index) => {
            state.areas.map((area) => {
              if (area.id === device.grid_area_id) {
                area.endpoints.map((endpoint) => {
                  device.endpoints.map((endpointDevice) => {
                    if (endpoint.id === endpointDevice.id) {
                      // @TODO: Wieder einbauen
                      // endpoint.device = device;
                      // endpoint.hasDevice = true;
                    }
                  });
                });
              }
            });
            if (index === resp.data.data.length - 1 && !noReload) {
              state.disorderAreaId = -1;
            }
          });
        });
    },
  },
};

export default gridAreas;
